import React from 'react';

import QuizFamily from './QuizFamily';
import FlashCardFamily from './FlashCardFamily';
import AccordionFamily from './AccordionFamily';

export default (props) => {
  const lesson = props.lesson;
  const family = lesson.family;
  const variant = lesson.variant;

  switch (family) {
    case 'knowledge':
      return <QuizFamily lesson={lesson} editable={props.editable} dispatch={props.dispatch} />;
    // case 'flashcard':
    //   return (
    //     <FlashCardFamily lesson={lesson} editable={props.editable} dispatch={props.dispatch} />
    //   );
    case 'interactive':
      if (variant === 'flashcardStack' || variant === 'flashcardGrid') {
        return (
          <FlashCardFamily lesson={lesson} editable={props.editable} dispatch={props.dispatch} />
        );
      }
      if (variant === 'accordion' || variant === 'tabs') {
        return (
          <AccordionFamily lesson={lesson} editable={props.editable} dispatch={props.dispatch} />
        );
      }
      return null;
    // return (
    //   <AccordionFamily lesson={lesson} editable={props.editable} dispatch={props.dispatch} />
    // );
    default:
      return null;
  }
};
